export default "__VITE_ASSET__D86JubUg__"